import { Typography } from '@/components';
import { FormFieldContainer } from '@/components/Form/Form.styles';
import ErrorMessage from '@/components/FormField/components/ErrorMessage';
import { CheckboxWrapper } from '@/components/FormField/components/FormFieldType/Checkbox/Checkbox.styles';
import { TextInputWrapper } from '@/components/FormField/components/FormFieldType/Input/Input.styles';
import { LoginButtonWrapper } from '@/components/SsoLoginButton/SsoLoginButton.styles';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

export const SignUpWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flex: 1,

  [LoginButtonWrapper]: {
    width: '100%',
  },

  [TextInputWrapper]: {
    marginTop: 0,
  },

  [FormFieldContainer]: {
    margin: 0,
    [CheckboxWrapper]: {
      marginTop: theme.spacing[16],
    },
  },

  [ErrorMessage]: {
    marginBottom: 0,
  },
}));

export const PopupGraphic = styled.div<{ isDesktop: boolean }>(({ isDesktop, theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: isDesktop ? theme.spacing[16] : theme.spacing[24],
}));

export const PopUpTexts = styled.div<{ isESPopup: boolean }>(({ isESPopup, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  '> :not(:last-child)': {
    marginBottom: theme.spacing[4],
  },
  // conditionals
  ...(isESPopup && { marginBottom: theme.spacing[8] }),
}));

export const JoinUsMainText = styled(Typography).attrs({
  variant: TextStyles['Heading 2'],
})<{ isDesktop: boolean }>(({ theme, isDesktop }) => ({
  textAlign: 'center',
  WebkitLineClamp: 3,
  wordBreak: 'break-word',
  display: isDesktop ? 'none' : '-webkit-box',

  [`${theme.mediaBreakpointUp.lg}`]: {
    display: isDesktop ? '-webkit-box' : 'none',
  },
}));

export const JoinUsSubtext = styled(Typography).attrs({
  variant: TextStyles['Body Text Large'],
})(({ theme }) => ({
  color: theme.colors.mediumEmphasisBlack,
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  textAlign: 'center',
  wordBreak: 'break-word',
}));

export const ButtonList = styled.div<{ isESPopup: boolean }>(({ theme, isESPopup }) => ({
  width: '100%',
  textAlign: 'center',
  marginTop: isESPopup ? 0 : theme.spacing[24],
  display: 'flex',
  flexDirection: 'column',

  '> :last-child': {
    marginBottom: isESPopup ? theme.spacing[36] : 0,
  },

  '> :first-child': {
    marginBottom: isESPopup ? 0 : theme.spacing[12],
  },
}));
